import { createRouter, createWebHashHistory } from "vue-router";

import AccessView from '../views/AccessView';
import AccessValidate from '../views/AccessValidate';
import AccessRemember from '../views/AccessRemember';
import AccessReset from '../views/AccessReset';
import NotFound from '../views/NotFound';
import ProfileHome from '../views/ProfileHome';
import ProfileSetting from '../views/ProfileSetting';
import ProfileCertificate from '../views/ProfileCertificate';
import ShowcasePublic from '../views/ShowcasePublic';
import ConvocatoryRegister from "../views/ConvocatoryRegister";
import ConvocatoryAssistance from "../views/ConvocatoryAssistance";
import SurveySatisfaction from '../views/SurveySatisfaction';
import SurveyThermometer from '../views/SurveyThermometer';
import SurveyVolunteering from '../views/SurveyVolunteering';
import EventRegister from '../views/EventRegister';
import EventAssistance from '../views/EventAssistance';
import InstrumentSearch from "@/views/InstrumentSearch";
import InstrumentClassic from "@/views/InstrumentClassic";
import InstrumentAdaptative from "@/views/InstrumentAdaptative.vue";

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  routes: [
    { path: '/', component: NotFound },
    { path: '/access', name: 'access', component: AccessView },
    { path: '/access/validate/:token/:inscription', name: 'accessvalidate', component: AccessValidate },
    { path: '/access/remember', name: 'accessremember', component: AccessRemember },
    { path: '/access/resetpassword/:token/:document', name: 'accessreset', component: AccessReset },
    { path: '/profile/home', name:'profilehome' , component: ProfileHome },
    { path: '/profile/setting', name:'profilesetting' , component: ProfileSetting },
    { path: '/profile/qualified', name: 'profilequalified', component: ProfileCertificate },
    { path: '/convocatoria/:code', name: 'showcasepublic', component: ShowcasePublic },
    { path: '/convocatoria/inscripciones/:route/:code', name: 'convocatoryregister', component: ConvocatoryRegister },
    { path: '/convocatoria/asistencia/:session', name: 'convocatoryassistance', component: ConvocatoryAssistance },
    { path: '/encuesta/satisfaccion/:session', name: 'surveysatisfaction', component: SurveySatisfaction },
    { path: '/encuesta/termometro/:session', name: 'surveythermometer', component: SurveyThermometer },
    { path: '/encuesta/voluntariado/:session', name: 'surveyvolunteering', component: SurveyVolunteering},
    { path: '/evento/registro/:code', name: 'eventregister', component: EventRegister},
    { path: '/evento/asistencia/:session', name: 'eventassistance', component: EventAssistance },
    { path: '/instrumentos/:code', name: 'instrumentsearch', component: InstrumentSearch },
    { path: '/instrumentos/resolver/clasico', name: 'instrumentclassic', component: InstrumentClassic },
    { path: '/instrumentos/resolver/adaptativo', name: 'instrumentadaptative', component: InstrumentAdaptative},
    { path: '/:pathMatch(.*)', name: 'errorpage', component: NotFound }
  ]
});

export default router;